import styled from '@emotion/styled';
import React from 'react';
import { Modal, pxToRem } from '@modernhealth/vital-components';
import { DailyPauseCalendarUrls } from '../hooks/useDailyPauseReminderCalendarUrls';
import { EventCalendarModalContent } from './EventCalendarModalContent';

type EventCalendarModalProps = {
    handleModalClose: () => void;
    isVisible: boolean;
    loading: boolean;
    onCalendarEventClick: (calendarUrlType: DailyPauseCalendarUrls) => void;
    callback?: () => void;
};

export const EventCalendarModal: React.FC<EventCalendarModalProps> = ({
    handleModalClose,
    isVisible,
    loading,
    onCalendarEventClick,
    callback,
}) => {
    const handleCalendarButtonClick = (calendarUrlType: DailyPauseCalendarUrls) => {
        onCalendarEventClick(calendarUrlType);
        handleModalClose();

        if (callback) {
            callback();
        }
    };

    return (
        <Modal
            onCloseButtonClick={handleModalClose}
            maxWidth={576}
            isVisible={isVisible}
            noPaddings
        >
            <ContentWrapper>
                <EventCalendarModalContent
                    handleCalendarButtonClick={handleCalendarButtonClick}
                    loading={loading}
                />
            </ContentWrapper>
        </Modal>
    );
};

const ContentWrapper = styled.div({
    padding: pxToRem(76, 38, 78),
});
